import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { BoardDocumentsService } from "src/app/services/board-documents.service";
import { BoardDocumentsResponseModel } from "src/app/model/BoardDocumentsResponseModel";

@Component({
  selector: "app-secure-board-document",
  templateUrl: "./board-document.component.html",
  styleUrls: ["./board-document.component.scss"],
})
export class BoardDocumentComponent implements OnInit {
    isLoading: boolean = false;
    boardDocumentKey: number;
    boardDocumentDetail: BoardDocumentsResponseModel;
    submitDisabled: boolean;
    pageMode: string;
    boards: {[key: number]: string};
    form: FormGroup = new FormGroup({});
    selectedUrlEn: File;
    selectedUrlMr: File;
    urlEnBase64String: string | ArrayBuffer;
    urlMrBase64String: string | ArrayBuffer;
    changeFileEn: boolean = true;
    changeFileMr: boolean = true;
    isDownloading: boolean = false;

    constructor(private router: Router, private route: ActivatedRoute,  
        private boardDocumentsService: BoardDocumentsService) { }
    
    ngOnInit(): void { 
        this.isLoading = true;
        this.boardDocumentsService
        .initBoardDocumentsForm()
        .subscribe((data: any) => {
            this.isLoading = false;
            if(data.status === 'SUCCESS') {
                this.boards = data.boards;
                this.route.params.subscribe((params: Params) => {
                    this.boardDocumentKey = +params["key"];      
                    console.log('this.boardDocumentKey', this.boardDocumentKey);
                    if(this.boardDocumentKey) {
                        this.isLoading = true;
                        this.boardDocumentsService
                        .getBoardDocumentBykey(this.boardDocumentKey)
                        .subscribe((data1: any) => {
                            this.isLoading = false;
                            console.log(data1);
                            this.boardDocumentDetail = data1;
                            this.pageMode = "Edit";                            
                            this.changeFileEn = false;
                            this.changeFileMr = false;
                            this.urlEnBase64String = this.boardDocumentDetail.urlEnBase64;
                            this.urlMrBase64String = this.boardDocumentDetail.urlMrBase64;

                            this.form.patchValue({
                                boardKey: {key: this.boardDocumentDetail.boardKey, value: this.boards[this.boardDocumentDetail.boardKey]},
                                headerLabelEn: this.boardDocumentDetail.headerLabelEn,
                                headerLabelMr: this.boardDocumentDetail.headerLabelMr,
                                displayOrder: this.boardDocumentDetail.displayOrder,
                                fileType: this.boardDocumentDetail.fileType
                            });
                        }, error => {
                            this.isLoading = false;
                        });
                    }
                    else {
                        this.pageMode = "Add";
                    }
                });
            }
            else {
                this.boardDocumentsService.errorToast(data.errorMessage, 5*1000);
            }
        }, error => {
            this.isLoading = false;
        });
        this.form = new FormGroup({
            boardKey: new FormControl(null, Validators.required),
            headerLabelEn: new FormControl(null, Validators.required),
            headerLabelMr: new FormControl(null, Validators.required),
            displayOrder: new FormControl(null, Validators.required),
            fileType: new FormControl(null, Validators.required),
            urlEn: new FormControl(null),
            urlMr: new FormControl(null),
        });
    }
    
    onSubmit() {
        if (this.form.valid) {
          if(this.pageMode === 'Add') {
            if(!this.urlEnBase64String) {
                this.boardDocumentsService.errorToast("File in English is required.");
            }
            else if(!this.urlMrBase64String) {
                this.boardDocumentsService.errorToast("File in Marathi is required.");
            }
            else {
                this.save();
            }
          }
          else {
            this.update();
          }
        } 
        else {
          this.submitDisabled = false;
        }
    }
    
    async save() {
        this.isLoading = true;
        this.boardDocumentsService
        .saveBoardDocument({
            boardKey: +this.form.value.boardKey?.key,
            headerLabelEn: this.form.value.headerLabelEn,
            headerLabelMr: this.form.value.headerLabelMr,
            displayOrder: +this.form.value.displayOrder,
            fileType: this.form.value.fileType,
            urlEnBase64String: this.urlEnBase64String,
            urlMrBase64String: this.urlMrBase64String,
        })
        .subscribe((data: any) => {
            this.isLoading = false;
            if(data.status === 'SUCCESS') {
                this.boardDocumentsService.successToast("Saved Successfully");
                this.router.navigate(["/secure", "board-documents-list"]);
            }
            else {
                this.submitDisabled = false;
                this.boardDocumentsService.errorToast(data.errorMessage);
            }
        }, error => {
            this.submitDisabled = false;
            this.isLoading = false;
            console.log(error);
            this.boardDocumentsService.errorToast(error.error.errorMessage, 5*1000);
        });  
    }
    
    async update() {
        this.isLoading = true;
        this.boardDocumentsService
        .updateBoardDocument(this.boardDocumentKey, {
            boardKey: +this.form.value.boardKey?.key,
            headerLabelEn: this.form.value.headerLabelEn,
            headerLabelMr: this.form.value.headerLabelMr,
            displayOrder: +this.form.value.displayOrder,
            fileType: this.form.value.fileType,
            urlEnBase64String: this.changeFileEn ? this.urlEnBase64String : 'NO_UPDATE',
            urlMrBase64String: this.changeFileMr ? this.urlMrBase64String : 'NO_UPDATE',
        }).subscribe((data: any) => {
            this.isLoading = false;
            if(data.status === 'SUCCESS') {
                this.boardDocumentsService.successToast("Updated Successfully");
                this.router.navigate(["/secure", "board-documents-list"]);
            }
            else {
                this.submitDisabled = false;
                this.boardDocumentsService.errorToast(data.errorMessage);
            }
        }, error => {
            this.submitDisabled = false;
            this.isLoading = false;
            console.log(error);
            this.boardDocumentsService.errorToast(error.error.errorMessage, 5*1000);
        });    
    }

    showBDD(o1: any, o2: any) {    
        if(o1 && o2 && o1.key == o2.key) {
          return o1.value;
        }
        else {
          return "";
        }
    }

    showFileType(o1: any, o2: any) {    
        if(o1 && o2 && o1 == o2) {
          return o1;
        }
        else {
          return "";
        }
    }

    onFileSelect(event, type) {
        if(type === 'EN') {
            this.selectedUrlEn = event.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(this.selectedUrlEn);
            reader.onload = () => {
                this.urlEnBase64String = reader.result
            };
        }
        else {
            this.selectedUrlMr = event.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(this.selectedUrlMr);
            reader.onload = () => {
                this.urlMrBase64String = reader.result
            };
        }
    }

    downloadFile(base64:string | ArrayBuffer, type:string){
        this.isDownloading = true;
        console.log('in download file', base64);
        let ext = this.form.value.fileType === 'HTML' ? '.html' : '.pdf';
        const src = `${base64}`;
        const link = document.createElement("a");
        link.href = src;
        link.download = this.form.value.headerLabelEn+"_"+type+ext;
        console.log('in download file name', link.download);
        link.click();
        link.remove();
        this.isDownloading = false;
    }
}